export default function Faq() {
	const faq_container = document.querySelectorAll( '.faq-block__body' );
	if ( faq_container ) {
		faq_container.forEach( function ( el ) {
			el.addEventListener( 'click', function ( e ) {
				const items = el.querySelectorAll( '.faqs-btn' )
				const target = e.target
				Array.from( items ).forEach( item => {
					if ( item !== target ) {
						item.classList.remove( 'show' )
					}
				} )
				target.classList.toggle( 'show' )
			} )
		} );
	}
}